import React from 'react';

const THead = ({ onSortChange }) => {
    return (
        <thead>
            <tr>
                <th onClick={() => onSortChange('country')}>Country</th>
                <th onClick={() => onSortChange('device')}>Device</th>
                <th onClick={() => onSortChange('spends')}>Spends</th>
                <th onClick={() => onSortChange('conversions')}>Conversions</th>
                <th onClick={() => onSortChange('eCost')}>eCost</th>
            </tr>
        </thead>
    );
};

export default THead;



// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/PeriodTable/components/THead/index.js